export enum DefaultStates {
    Init = "init",
    Error = "error",
    Preload = "preload",
    JackpotAttendance = "jackpot_attendance",
    JackpotWin = "jackpot_win",
    Recover = "recover",
    RecoverSpin = "recover_spin",
    EnterFreeSpins = "enter_freespins",
    ExitFreeSpins = "exit_freespins",
    Idle = "idle",
    Spin = "spin",
    GetSpinResult = "get_spin_result",
    SpinResult = "spin_result",
    SpinEnd = "spin_end",
    Finish = "finish",
    ShowWin = "show_win",
    BigWin = "big_win",
    LoopLines = "loop_lines",
    RealityCheck = "reality_check"
}